import React from 'react';
import ContactUsForm from '../../common/components/Forms/ContactUsForm';

function ContactUsSection() {
  return (
    <section className="section contact-us-section">
      <ContactUsForm />
    </section>
  );
}

export default ContactUsSection;
